module.exports = __webpack_public_path__ + "static/media/01.ab7662de.jpg";